import { Outlet, createFileRoute } from '@tanstack/react-router';

// Layout-only route: `/creator/content` owns the content-list index plus the
// `$contentId/edit` and `$contentId/preview` children. It must render an
// <Outlet /> so those children have somewhere to mount — without it, the edit
// and preview links change the URL but render nothing (the list stayed on
// screen). The list lives in creator.content.index.tsx; the section's role
// guard runs in each page (index + edit + preview), so this layout is a bare
// passthrough.
export const Route = createFileRoute('/creator/content')({
  component: () => <Outlet />,
});
